import { KameleoonFlagKey, useFeatureFlagValue } from '@lingoda/kameleoon';

export const useIsOnboardingReworkEnabled = () => {
    const flag = useFeatureFlagValue(KameleoonFlagKey.onboardingReworkWeb);

    return {
        isLoading: flag.isLoading,
        isEnabled: !flag.isLoading && flag.isVariant,
    };
};
